import React from 'react';
import { FieldDisplayProps } from '../../types';

// Color palette for tags
const TAG_COLORS = [
  { bg: '#dbeafe', text: '#1e40af' }, // Blue
  { bg: '#dcfce7', text: '#166534' }, // Green
  { bg: '#fef3c7', text: '#92400e' }, // Yellow
  { bg: '#fce7f3', text: '#9d174d' }, // Pink
  { bg: '#e0e7ff', text: '#3730a3' }, // Indigo
  { bg: '#fed7d7', text: '#9b2c2c' }, // Red
  { bg: '#d1fae5', text: '#065f46' }, // Teal
  { bg: '#fef9c3', text: '#854d0e' }, // Amber
  { bg: '#ede9fe', text: '#5b21b6' }, // Purple
  { bg: '#cffafe', text: '#155e75' }, // Cyan
];

const getTagColor = (value: string, options?: string[]) => {
  const index = options?.indexOf(value) ?? 0;
  return TAG_COLORS[Math.abs(index) % TAG_COLORS.length];
};

export const MultiSelectFieldDisplay: React.FC<FieldDisplayProps> = ({
  value,
  fieldDefinition,
  onStartEditing,
  isReadOnly,
}) => {
  const handleClick = () => {
    if (!isReadOnly) {
      onStartEditing();
    }
  };

  if (!value) {
    return (
      <div
        className="pill custom-field-pill editable empty-placeholder"
        onClick={handleClick}
      />
    );
  }

  // Parse multi-select values
  let values: string[] = [];
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) {
      values = parsed;
    } else {
      values = [value];
    }
  } catch {
    // Might be comma-separated string
    values = value.split(',').map((v) => v.trim()).filter(Boolean);
  }

  const options = 'options' in fieldDefinition ? fieldDefinition.options : [];

  return (
    <div
      className="multiselect-cell editable"
      onDoubleClick={handleClick}
      onClick={handleClick}
    >
      {values.map((v, index) => {
        const color = getTagColor(v, options);
        return (
          <span
            key={index}
            className="pill tag-pill"
            style={{
              backgroundColor: color.bg,
              color: color.text,
              marginRight: index < values.length - 1 ? '4px' : '0',
            }}
          >
            {v}
          </span>
        );
      })}
    </div>
  );
};

export default MultiSelectFieldDisplay;
